import { LocalDate } from '../../core/model/local-date';
import { RentalObjectCategory } from './const/enums';

export class LeaseAgreementRentalObject {
  constructor(dataContext?: any) {
    if (dataContext) {
      if (dataContext.rentalObjectId) {
        this.rentalObjectId = dataContext.rentalObjectId.id ? dataContext.rentalObjectId.id : dataContext.rentalObjectId;
      }
      this.linkOrder = dataContext.linkOrder ? dataContext.linkOrder : 0;
      this.fromDate = dataContext.fromDate;
      this.toDate = dataContext.toDate;
      this.category = dataContext.category;
    }
  }

  category: RentalObjectCategory;
  rentalObjectId: string;
  linkOrder: number = 0;
  fromDate: LocalDate;
  toDate: LocalDate;
}
